// extracted by mini-css-extract-plugin
export default {"icon":"tL5Z9k","icon--absolute-right":"SzbMQ4","icon--button":"wDLwn5","icon--error":"VSsw4u","icon--disabled":"mFnyQC"};